export const MOLE_SPEED_MULTIPLIER = 0.6;
export const FRUITS_SPEED_MULTIPLIER = 0.6;
export const FRUITS_CLEAR_DIFFERENCE = 3;
export const PRECISION_MAX_DISTANCE = 64;
export const PRECISION_JOYSTICK_HEIGHT = 148;
export const MEMORY_END_TIMEOUT = 500;
